import React, {ReactNode, useEffect, useRef, useState} from "react";
import {useIdleTimer} from "react-idle-timer";
import TimeoutCountdown from "../modals/TimeoutCountdown";
import {inactivityTimeOut, inactivityCountdown} from "../../config/global";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";


interface IProps {
    isAuthenticated: boolean | null,
    logOut: any
}

let countdownInterval: NodeJS.Timer;
let timeout: NodeJS.Timeout;
let timerRemainingTime: NodeJS.Timer;

const TimeoutIdleTimer = ({ isAuthenticated, logOut, ...props }: IProps)  => {


    const { extendAppUniqueTokenCookieExpiration, removeAppUniqueToken } = useAppUniqueToken();
    const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
    const [timeoutCountdown, setTimeoutCountdown] = useState(0);

    const clearSessionTimeout = () => {
        clearTimeout(timeout);
    };

    const clearSessionInterval = () => {
        //console.log('clearSessionInterval');

        clearInterval(countdownInterval);
    };

    const handleLogout = async (isTimedOut = false) => {
        //console.log('TimeoutIdleTimer: handleLogout');

        try {
            removeAppUniqueToken();

            isAuthenticated = false;

            setTimeoutModalOpen(false);
            clearSessionInterval();
            clearSessionTimeout();

            //logOut();
        } catch (err) {
            console.error(err);
        }
    };

    const handleContinue = () => {
        //console.log('handleContinue');

        try {

            setTimeoutModalOpen(false);
            clearSessionInterval();
            clearSessionTimeout();

            extendAppUniqueTokenCookieExpiration();
        } catch (err) {
            console.error(err);
        }
    };


    const onActive = () => {
        //console.log('onActive')

        if (!timeoutModalOpen) {
            //console.log('timeoutModalOpen: ' + timeoutModalOpen)

            clearSessionInterval();
            clearSessionTimeout();
        }
    };
    const onPresenceChange = () => {

    };
    const handleIdle = () => {
/*
        let name;
        let value;
        for(let i=0; i<Object.keys(isAuthenticated).length; i++){

            // Get the name and value of the old object
            name = Object.keys(isAuthenticated)[i];
            value = isAuthenticated[name];

            console.log(name + '-> ' + value);
        };

*/
        if (isAuthenticated &&!timeoutModalOpen) {
        //if (!timeoutModalOpen) {
            timeout = setTimeout(() => {
                let countDown = inactivityCountdown;

                setTimeoutModalOpen(true);
                setTimeoutCountdown(countDown);

                countdownInterval = setInterval(() => {
                    if (countDown > 1)
                    {
                        setTimeoutCountdown(--countDown);
                    }
                    else
                    {
                        handleLogout(true);
                    }
                }, 1000);
            }, 1000);
        }
    };


    const idleTimeRef = useRef(null);
    const { getRemainingTime } = useIdleTimer({
        crossTab: true,
        //ref: idleTimeRef,
        timeout: inactivityTimeOut,
        debounce: 250,
        onIdle: handleIdle,
        //onActive: onActive
        startOnMount: true,
        //element: document
    });
/*
    const [timeVal, setTimeVal] = useState(0);
    useEffect(() => {

        if (isAuthenticated)
        {
            timerRemainingTime = setInterval(() => {
                setTimeVal(getRemainingTime());
            }, 1000);
        }
        else
            clearInterval(timerRemainingTime);


    }, [isAuthenticated]);
    useEffect(() => {

        console.log('timeout in : ' + timeVal);

    }, [timeVal]);
*/
    return (
        <TimeoutCountdown
            countdown={timeoutCountdown}
            onContinue={handleContinue}
            onLogout={() => handleLogout(false)}
            open={timeoutModalOpen}
        />
    );
}

export default TimeoutIdleTimer;
